import React from 'react'
import Navbar from '@/components/Navbar'
import HeaderBar from '@/components/HeaderBar'
import './DashboardPage.css'
import { Helmet } from 'react-helmet-async'
import { PAGES } from '@/constants/pages'
import { Link } from 'react-router-dom'
import { EXTERNAL_LINKS } from '@/constants/externalLinks'

export default function DashboardPage() {
  return (
    <div className="page-container">
      <Helmet>
        <title>{PAGES.DASHBOARD.title}</title>
      </Helmet>
      <Navbar />
      <main className="page-main-content">
        <HeaderBar />
        <div className="page-content dashboard-layout">
          <div className="dashboard-hero">
            <div className="hero-left">
              <img src="/images/logo_1.png" alt="SoloProtect" className="hero-logo" />
              
              <div className="hero-text-content">
                <h1>Welcome to the SoloProtect<br />Device Management Platform</h1>
                <p>You can manage your devices and your internal platform users here.</p>
                <p>Help and support is available through the Partner Resources link on the side menu or <Link to={EXTERNAL_LINKS.PARTNER_RESOURCES.to} target="_blank">click here</Link></p>
              </div>
            </div>

            <div className="hero-right">
              <img src="/images/worker.png" alt="Worker" className="worker-image" />
            </div>

          </div>
        </div>
      </main>
    </div>
  );
}
